import Map from './Map';
import { StyledMapContainer } from './styles';

export const MapContainer = StyledMapContainer;
export default Map;
